import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Translate } from "react-redux-i18n";

import Rating from "../../utils/components/Rating";

import { parseAddress } from "../../utils/Utils";

import "../../../styles/components/insights/insights/FavoriteCP.scss";
import marker from "../../../styles/images/markers/marker_public_grey.svg";
import evio_marker from "../../../styles/images/markers/marker_evio.svg";
import "../../../styles/utils/_loadingScreen.scss";

class FavoriteCP extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="favoriteCP" className="highlight-container">
        {!this.props.loading ? (
          <>
            <div className="highlight-container-header">
              <img src={marker} alt="" />
              <Translate value="backOffice_insights_cpImostUse" />
            </div>
            <div className="highlight-container-body">
              <div className="cp-container">
                <div className="cp-icon">
                  {this.props.cp &&
                  !_.isEmpty(this.props.cp) &&
                  this.props.cp.imageContent &&
                  this.props.cp.imageContent !== "" ? (
                    <img src={this.props.cp.imageContent} alt="" />
                  ) : this.props.cp &&
                    this.props.cp.defaultImage &&
                    this.props.cp.defaultImage !== "" ? (
                    <img src={this.props.cp.defaultImage} alt="" />
                  ) : (
                    <img
                      src={
                        this.props.brand?.icons?.mapIcons?.[
                          `marker_${_.camelCase(this.props.brand?.brandName)}`
                        ] || evio_marker
                      }
                      alt=""
                      style={{ objectFit: "scale-down" }}
                    />
                  )}
                </div>
                {this.props.cp && !_.isEmpty(this.props.cp) && (
                  <div className="cp-info">
                    <Rating value={Math.round(this.props.cp.rating)} />
                    <p>{this.props.cp.name}</p>
                    <p>
                      {parseAddress(this.props.cp.address).length < 25
                        ? parseAddress(this.props.cp.address)
                        : parseAddress(this.props.cp.address).substring(0, 25) + "..."}
                    </p>
                  </div>
                )}
              </div>

              <div className="most-used-cp-container">
                {this.props.lastUsedCP && !_.isEmpty(this.props.lastUsedCP) && (
                  <>
                    <div className="cp-title">
                      <Translate value="backOffice_insights_lastUsedCP" />
                    </div>
                    <div className="cp-content-area">
                      <div className="cp-icon">
                        {this.props.lastUsedCP.imageContent &&
                        this.props.lastUsedCP.imageContent !== "" ? (
                          <img src={this.props.lastUsedCP.imageContent} alt="" />
                        ) : this.props.lastUsedCP.defaultImage &&
                          this.props.lastUsedCP.defaultImage !== "" ? (
                          <img src={this.props.lastUsedCP.defaultImage} alt="" />
                        ) : (
                          <img src={evio_marker} alt="" style={{ objectFit: "scale-down" }} />
                        )}
                      </div>
                      <div className="cp-info">
                        <Rating value={Math.round(this.props.lastUsedCP.rating)} />
                        <p>{this.props.lastUsedCP.name}</p>
                        <p>
                          {parseAddress(this.props.lastUsedCP.address).length < 25
                            ? parseAddress(this.props.lastUsedCP.address)
                            : parseAddress(this.props.lastUsedCP.address).substring(0, 25) + "..."}
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="generic-loading">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(FavoriteCP);
